module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CN ParaOverride-6",
    attrs: {
      "id": "_idParaDest-6"
    }
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_vm._v("Wisdom comes to us when it can no longer do any good.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st ParaOverride-9",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("—")]), _vm._v("Gabriel García Márquez")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17f80a02","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eBook_V45575.vue
// module id = 78
// module chunks = 0